module.exports = __webpack_public_path__ + "media/icons/x-4687bfef.svg";